var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8337 7L13.207 5.14L13.4337 2.68L11.027 2.13333L9.76699 0L7.50033 0.973333L5.23366 0L3.97366 2.12667L1.56699 2.66667L1.79366 5.13333L0.166992 7L1.79366 8.86L1.56699 11.3267L3.97366 11.8733L5.23366 14L7.50033 13.02L9.76699 13.9933L11.027 11.8667L13.4337 11.32L13.207 8.86L14.8337 7ZM5.75366 9.67333L4.16699 8.07333C3.90699 7.81333 3.90699 7.39333 4.16699 7.13333L4.21366 7.08667C4.47366 6.82667 4.90033 6.82667 5.16033 7.08667L6.23366 8.16667L9.66699 4.72667C9.92699 4.46667 10.3537 4.46667 10.6137 4.72667L10.6603 4.77333C10.9203 5.03333 10.9203 5.45333 10.6603 5.71333L6.71366 9.67333C6.44033 9.93333 6.02033 9.93333 5.75366 9.67333Z",
    fill: "#52AD33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/ApprovedIcon.e3cae466f0f4c0b98cda9b17405fb2a7.svg";
export { ForwardRef as ReactComponent };